<fieldset [disabled]="!service.editable">
	<div class="d-flex pt-3">
		<button mat-raised-button color="primary" [disabled]="!service.editable">
			<input class="ng-hide" id="input-file-id" type="file" (change)="uploadFile($event)" multiple />
			<label for="input-file-id" class="md-button md-raised md-primary"
				><i class="fa-solid fa-file-circle-plus"></i> Wgraj zdjęcie z pliku</label
			>
		</button>
	</div>
	<mat-table
		#dataTable
		*ngIf="service.data.serviceMultimedias"
		[dataSource]="service.data.serviceMultimedias"
		cdkDropList
		(cdkDropListDropped)="dropTable($event)"
		class="pb-3"
	>
		<ng-container matColumnDef="link">
			<mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div *ngIf="element.multimedia.url">
					<a [href]="element.multimedia.url" target="_blank">Link do zdjęcia</a>
				</div>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="url">
			<mat-header-cell *matHeaderCellDef> Zdjęcie </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<img [src]="element.multimedia.url" width="50%" />
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element; let index">
				<button mat-raised-button color="warn" [disabled]="!service.editable" (click)="deleteImage(index)">
					<i class="fa-solid fa-trash-can"></i> Usuń zdjęcie
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
</fieldset>
